import React from 'react'

import classnames from 'classnames'

import { MenuRecipeAvailabilityTag } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import css from './RecipeTag.css'

type RecipeTagProps = {
  tag: MenuRecipeAvailabilityTag | null
  type?: string
}

export const RecipeTag = ({ tag, type = 'span' }: RecipeTagProps) => {
  if (!tag) {
    return null
  }

  const { background_color: backgroundColor, color, name } = tag

  const style = {
    backgroundColor: backgroundColor.light,
    color: color.light,
    borderColor: backgroundColor.light ? '1px solid' : 'none',
  }

  return React.createElement(type, { className: classnames(css.recipeTag), style }, name)
}
